export const OIDC_CONFIG_KEY = 'nugsnet:sdk:oidc:config:v1'
export const OIDC_TRANSACTION_KEY = 'nugsnet:sdk:oidc:transaction'

export const SECOND = 1000
export const MINUTE = SECOND * 60

export const WEB_MESSAGE_RESPONSE_TYPE = 'authorization_response'

export const ORIGINS_ALLOWED_LIST = [
  'https://get.nugs.net',
  'https://get.nugsdev.net',
  'https://get.livephish.com',
  'https://get.livephishdev.com'
]

export const AUTHORITY_ORIGINS = [
  'id.nugsdev.net',
  'id.nugs.net',
  'id.livephish.com',
  'id.livephishdev.com'
]

export const CRYPTOSTORAGE_SECRET_KEY = 'DRE@#>@ao4?dfo$e!'
